import { submitEvent, submitMerge, submitMove } from '@otto-ec/tracking-bct'
import { EventTypes, TrackingPort } from '../ports'
import { LoggingPort } from '@otto-ec/eprivacy-shared'

export class TrackingBctAdapter<Labels extends Record<string, [string]>>
  implements TrackingPort<Labels>
{
  constructor(private readonly logger: LoggingPort) {}

  async track(eventName: EventTypes, labels: Labels): Promise<void> {
    try {
      switch (eventName) {
        case EventTypes.PageImpression:
          return await submitMerge<Labels>(labels)
        case EventTypes.Event:
          return await submitEvent<Labels>(labels)
        case EventTypes.Move:
          return await submitMove<Labels>(labels)
      }
    } catch (e) {
      this.logTrackingError(eventName, labels, e)
      return
    }
  }

  private logTrackingError(eventName: EventTypes, labels: Labels, e: unknown) {
    const entriesWithError = [
      ...Object.entries(labels).map(([key, value]) => [key, value[0]] as const),
    ]
    const labelsWithError = Object.fromEntries(entriesWithError)

    this.logger.error(
      new Error(`Error tracking event ${eventName}.`, { cause: e }),
      labelsWithError
    )
  }
}
